<template>
  <div class="images-container">
    <el-form ref="form" label-width="80px">
      <el-form-item label="上边距">
        <el-slider v-model="currentItem.style.margin_top" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <el-form-item label="左右边距">
        <el-slider v-model="currentItem.style.padding" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <el-form-item label="选择模板">
        <div class="template">
          <div
            class="template-item"
            :class="{active:currentItem.style.template==='template1'}"
            @click="templateChange('template1', '')">
            <img src="../images/template1.png">
            <span>1行1个</span>
          </div>
          <div
            class="template-item"
            :class="{active:currentItem.style.template==='template2'}"
            @click="templateChange('template2', 2)">
            <img src="../images/template2.png">
            <span>1行2个</span>
          </div>
          <div class="template-item"
            :class="{active:currentItem.style.template==='template3'}"
            @click="templateChange('template3', 3)">
            <img src="../images/template3.png">
            <span>1行3个</span>
          </div>
          <div class="template-item"
            :class="{active:currentItem.style.template==='template4'}"
            @click="templateChange('template4', 4)">
            <img src="../images/template4.png">
            <span>1行4个</span>
          </div>
          <div class="template-item"
            :class="{active:currentItem.style.template==='template5'}"
            @click="templateChange('template5', '')">
            <img src="../images/template5.png">
            <span>横向滑动</span>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="图片间隙">
        <el-slider size="small" v-model="currentItem.style.spacing" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <el-form-item label="图片">
        <draggable class="draggable" v-model="currentItem.images">
          <div class="images-item" v-for="(item,index) in currentItem.images" :key="index">
            <img class="img-item cursor-pointer" :src="item.src" @click="select(item.src, index)">
            <div class="right">
              <span>链接</span>
              <link-to v-model="item.link"></link-to>
            </div>
            <div class="btn-group">
              <i class="el-icon-plus gray cursor-pointer" @click="addItem(index)"></i>
              <i class="el-icon-delete gray cursor-pointer" @click="deleteItem(index)"></i>
            </div>
          </div>
        </draggable>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="volumeSelect">批量添加</el-button>
      </el-form-item>
    </el-form>
    <upload-img ref="upload"></upload-img>
  </div>
</template>
<script>
import UploadImg from '@/components/UploadImg'
import draggable from 'vuedraggable'
import linkTo from '@/components/link/link'
export default {
  name: 'imagesEditor',
  components: {
    UploadImg,
    draggable,
    linkTo
  },
  data () {
    return {
      currentImg: []
    }
  },
  computed: {
    currentItem () {
      return this.$store.state.page.currentItem
    }
  },
  methods: {
    templateChange (temp, limit) {
      this.currentItem.style.template = temp
    },
    addItem (index) {
      this.currentItem.images.splice(index + 1, 0, {
        src: 'https://resource.gezishops.com/2/images/detail/KtIdsSr7HKgF8LNV0VUDVXAf1V1xDpREokREVXkM.jpeg',
        link: {}
      })
    },
    deleteItem (index) {
      if (this.currentItem.images.length === 1) {
        return
      }
      this.currentItem.images.splice(index, 1)
    },
    select (src, index) {
      this.$refs.upload.show([src], 'detail', 1).then(res => {
        if (res.length === 1) {
          this.currentItem.images[index].src = res[0]
        }
      }).catch(_ => {})
    },
    volumeSelect () {
      this.$refs.upload.show([], 'detail', 30).then(res => {
        res.forEach(item => {
          this.currentItem.images.push({
            src: item,
            link: {}
          })
        })
      }).catch(_ => {})
    }
  }
}
</script>
<style lang="less" scoped>
.template {
  display: flex;
  flex-wrap: wrap;
  .template-item {
    width: 90px;
    height: 90px;
    margin-right: 10px;
    text-align: center;
    border: 1px solid #E4E7ED;
    &.active {
      border: 1px solid #409EFF;
    }
    img {
      width: 70px;
      height: auto;
      margin: 0 auto;
      margin-top: 6px;
      display: block;
    }
    span {
      font-size: 13px;
    }
  }
}
.images-item {
  display: flex;
  position: relative;
  padding: 10px;
  margin-bottom: 10px;
  background-color: #F2F6FC;
  .img-item {
    height: 60px;
    width: auto;
  }
  .right {
    height: 40px;
    margin-left: 10px;
    display: flex;
    align-items: center;
    span {
      margin-right: 5px;
      line-height: 1em;
    }
  }
  .btn-group {
    position: absolute;
    top: 0;
    right: 5px;
    i {
      margin-left: 10px;
      &.up {
        transform: rotate(90deg)
      }
      &.down {
        transform: rotate(-90deg)
      }
    }
  }
}
.product-item {
  background-color: #fff;
  width: 120px;
  margin-right: 8px;
  margin-bottom: 8px;
  padding: 5px;
  border: 1px solid #E4E7ED;
  box-sizing: border-box;
  .img {
    width: 100%;
    height: 110px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .name {
    font-size: 13px;
    color: #666666;
    text-align: center;
    line-height: 17px;
    height: 35px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageEditor/editors/imagesEditor.vue